import { useMemo } from "react";
import { Link } from "react-router-dom";
import { mentionSegments, truncateSegments } from "../../utils/mentions";

// Post or comment text with its resolved @mentions as profile links.
// `mentions` is the server's [{ user_id, username, token }]: only those
// tokens link, to the user's current username; the text itself is shown as
// written (an "@old_name" from before a rename keeps its wording but opens
// the right profile). Text is rendered as text, never HTML.
//
// `limit` truncates to that many characters (as String#slice counts) along
// segment boundaries, appending "..." — a mention is never cut in half.
export default function MentionText({ text, mentions, limit = null }) {
  const segments = useMemo(() => mentionSegments(text, mentions), [text, mentions]);
  const { segments: shown, truncated } =
    limit == null ? { segments, truncated: false } : truncateSegments(segments, limit);

  return (
    <>
      {shown.map((segment, index) =>
        segment.type === "mention" ? (
          <Link
            key={index}
            to={`/profiles/${encodeURIComponent(segment.mention.username)}`}
            title={`@${segment.mention.username}`}
            // Never also the row, card or button around the text.
            onClick={(e) => e.stopPropagation()}
            className="font-semibold text-blue-600 hover:underline"
          >
            {segment.text}
          </Link>
        ) : (
          segment.text
        )
      )}
      {truncated && "..."}
    </>
  );
}
